'use strict';

define('vb/private/configuration',[], () => {
  /**
   * The configuration object is used to store information on the current
   * configuration of the application.
   * This object is initialized once in main.js
   */
  class Configuration {
    constructor() {
      /**
       * The application URL. It is the URL showing in the browser running the application.
       * This URL can be different from the base URL used to retrieve the application resource.
       * This is will be used by the router sync navigation state and URL
       * See the configuration object in main.js for how it's calculated.
       * @type {string}
       */
      this.applicationUrl = null;

      /**
       * A string marker used in the URL when using the router path strategy to recognize
       * where in the URL the VB application path starts. This is used for the generic case
       * where vbInitConfig.APP_NAME is not defined.
       * For the URL https://host/pathname/vp/app/main/main-start
       * the VB path is /app/main/main-start
       * Page 'app' contains flow 'main' which contains page 'main-start'
       * The value is 'vp' and is defined once in main.js
       * @type {string}
       */
      this.urlMarker = null;

      /**
       * The name of the application as used in the URL. This value is copy from
       * vbInitConfig.APP_NAME. When it is set, it is used instead of urlMarker to
       * recognize where in the URL the application path starts.
       * For the URL https://host/pathname/<appName>/app/main/main-start
       * the VB path is /app/main/main-start
       * Page app contains flow main which contains page main-start
       * @type {string}
       */
      this.appName = null;

      /**
       * True when require-ut is used instead of require.
       * The value is set at init time in main.js by looking at the script tags
       * @type {boolean}
       */
      this.isRequireUt = false;
    }

    /**
     * @param {Object} configuration
     */
    init(configuration) {
      // Store a copy of this function for testing
      this.calculateApplicationUrl = configuration.calculateApplicationUrl;
      this.getBaseUrlFromConfig = configuration.getBaseUrlFromConfig;
      this.applicationUrl = configuration.applicationUrl;
      this.urlMarker = configuration.urlMarker || 'vp';
      this.appName = configuration.appName;
      this.isRequireUt = configuration.isRequireUt;
    }

    /**
     * Calculate the base URL given the values defined in the window.vbInitConfig
     * The body of this function is defined in the configuration object of  in main.js
     * and copied here to avoid duplication.
     * This is expected to be used on PWA to calculated the baseUrl.
     * @return {string}
     */
    // eslint-disable-next-line class-methods-use-this
    getBaseUrlFromConfig() {
      return null;
    }

    /**
     * Retrieve the sandbox id or the application. Currently uses the BASE_URL_TOKEN property but in
     * future, there will be a dedicated property on vbInitConfig
     * @return {string} an id describing the sandbox of the application
     */
    // eslint-disable-next-line class-methods-use-this
    getSandboxId() {
      const initConfig = globalThis.vbInitConfig || {};

      // Honor BASE_URL_TOKEN first
      const baseUrlToken = initConfig.BASE_URL_TOKEN || '';
      let sandbox = baseUrlToken.split('sb:')[1];
      if (!sandbox) {
        sandbox = initConfig.SANDBOX;
      }

      return sandbox;
    }
  }

  return new Configuration();
});

